import { useState, useRef } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/header.css";
import userimg from "../image/user.svg";
import menuicon from "../image/menu.svg";
import { useSidebar } from "../context/SidebarContext";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

const Header = () => {
  const { user, logout } = useAuth();
  // console.log("header user", user);

  const { isOpen } = useSidebar();
  const [dropdown, setDropdown] = useState(false);

  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { toggleSidebar } = useSidebar();

  const toggleDropdown = () => setDropdown((prev) => !prev);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const generateTitleFromPath = (path) => {
    const parts = path.split("/").filter(Boolean);

    if (parts.length === 0) return { title: "Dashboard", subtitle: "Dashboard Overview" };

    if (path.includes("/view-enquiry-details/")) return { title: "View Enquiry", subtitle: "" };

    if (path.includes("intelligence")) return { title: "Intelligence", subtitle: "Analytics & Reports" };

    if (path.includes("master-data/categories")) return { title: "Category", subtitle: "Manage Categories" };

    if (path.includes("master-data/unit")) return { title: "Units", subtitle: "Manage Units" };

    if (path.includes("master-data/products")) return { title: "Products", subtitle: "Manage Products" };

    if (path.includes("master-data/input-purchases")) return { title: "Input Purchases", subtitle: "Manage Farm Inputs" };

    if (path.includes("master-data/user-master")) return { title: "User Master", subtitle: "Manage Users" };

    if (path.includes("history")) return { title: "History", subtitle: "View All Activities" };

    if (path.includes("my-profile")) return { title: "My Profile", subtitle: "Manage Your Profile" };

    const lastPart = parts[parts.length - 1];
    let title = lastPart
      .replace(/[-_]/g, " ")
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/\b\w/g, (c) => c.toUpperCase());
    return { title, subtitle: "" };
  };

  const { title: currentPageTitle, subtitle: pageSubtitle } = generateTitleFromPath(location.pathname);

  return (
    <div className="mainhdr">
      <div className={isOpen ? "container-fluid" : "container-fluid"}>
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <button className="sidebar-menu-toggle" onClick={toggleSidebar}>
              <img src={menuicon} alt="menuicon" />
            </button>
            <div className="ms-3 d-none d-md-block">
              <h2>{currentPageTitle}</h2>

              {pageSubtitle && <span className="logo-text">{pageSubtitle}</span>}
            </div>
          </div>
          <div className="d-flex align-items-center">
            <div className="user-menu position-relative" ref={dropdownRef}>
              <div
                onClick={toggleDropdown}
                className="user-name mb-0 d-flex align-items-center user-name-cursor"
              >
                {user?.full_name || "User"}
                <div className="avatar ms-2">
                  <img
                    src={user?.avatar || userimg}
                    alt="User Avatar"
                    className="img-avatar"
                  />
                  <span className="avatar-status badge-success"></span>
                </div>
              </div>

              {dropdown && (
                <div className="user-box position-absolute">
                  <div className="user-hdr">
                    {user?.avatar ? (
                      <img src={user.avatar} alt="User Avatar" />
                    ) : (
                      <AccountCircleIcon fontSize="large" />
                    )}
                    <div className="user-name">
                      <h6>{user?.full_name}</h6>
                      <p>{user?.email}</p>
                    </div>
                  </div>
                  <div className="routeopt">
                    <div className="out" onClick={handleLogout}>
                      <i className="bi bi-box-arrow-right"></i> Sign Out
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
